import { UsPhoneLabel } from 'ui/components'
import { DateTime } from 'ui/components/DateTime'
import { NoWrap } from 'ui/components/NoWrap'
import { TableActions, TableColumn } from 'ui/components/Table'
import { ClientUserListResponseItem } from '~bank-client-users/types'

import { Permissions } from '../Permissions'

export const columns = (
  setShowUserRelationships: (item: ClientUserListResponseItem) => void,
  setEditClientUser: (item: ClientUserListResponseItem) => void,
  removeClientUser: (item: ClientUserListResponseItem) => void,
  sendInviteLink: ({ id }: { id: string }) => void
): TableColumn<ClientUserListResponseItem>[] => [
  {
    title: 'First Name',
    key: 'name',
    align: 'left'
  },
  {
    title: 'Email',
    align: 'left',
    render: ({ email }) => <NoWrap>{email}</NoWrap>
  },
  {
    title: 'Phone',
    align: 'left',
    width: '130px',
    render: ({ phone }) => <UsPhoneLabel value={phone || ''} />
  },
  {
    title: 'Relationships',
    align: 'left',
    render: (item) =>
      item.assignedRelationships.map((relationship, index) => (
        <span
          key={index}
          onClick={() => setShowUserRelationships(item)}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {relationship.name}
          {index < item.assignedRelationships.length - 1 && ', '}
        </span>
      ))
  },
  {
    title: 'Permissions',
    align: 'left',
    render: ({ email, permissions }) => <Permissions id={email} value={permissions} />
  },
  {
    title: 'Created',
    render: ({ createdAt }) => <DateTime withTime date={createdAt} />
  },
  {
    title: 'Last Login',
    render: ({ lastLoginAt }) => <DateTime withTime date={lastLoginAt} />
  },
  {
    title: 'Action(s)',
    align: 'center',
    render: (item: ClientUserListResponseItem) =>
      (item.enableResendInviteLink || item.enableEdit || item.enableRemove) && (
        <TableActions
          items={[
            ...(item.enableResendInviteLink
              ? [
                  {
                    title: 'Resend invite link',
                    type: 'option' as const,
                    onClick: () => sendInviteLink({ id: item.id })
                  }
                ]
              : []),
            ...(item.enableEdit
              ? [
                  {
                    type: 'edit' as const,
                    onClick: () => setEditClientUser(item)
                  }
                ]
              : []),
            ...(item.enableRemove
              ? [
                  {
                    type: 'delete' as const,
                    onClick: () => removeClientUser(item)
                  }
                ]
              : [])
          ]}
        />
      )
  }
]
